import { Component, Input, OnInit } from '@angular/core';
import { Router } from "@angular/router"

@Component({
    selector: 'app-social-security-benefit-card',
    templateUrl: './social-security-benefit-card.component.html',
    styleUrls: ['social-security-benefit-card.component.css']
})

export class SocialSecurityBenefitCardComponent implements OnInit {
    @Input() scenario: string = "";
    @Input() color: string = "";
    @Input() ages: any = { clientAge: 0, clientMonths: 0, spouseAge: 0, spouseMonths: 0 };
    @Input() amount: number = 0;
    @Input() includeCheck: boolean = false;
    cardType: any;

    constructor() {
        
    }

    ngOnInit() {
        this.cardType = (this.scenario.includes('Second Alternate') || this.scenario == 'Alternate (Retroactive File)' || this.scenario == 'Alternate') ? 'alternate' 
        : (this.scenario.includes('First Alternate') || this.scenario == 'FRA') ? 'fra' 
        : (this.scenario.includes('Earliest')) ? 'earliest' 
        : 'optimal';
    }
}